import QuestionInsightDisplayModes from "consts/QuestionInsightDisplayModes";

const QuestionInsightDisplayModeOptions = [
  {
    text: "Insight List: Differences in Answer Likelihood",
    value: QuestionInsightDisplayModes.ANSWER_DIFFERENCES,
  },
  {
    text: "Insight List: Differences in Trait Likelihood",
    value: QuestionInsightDisplayModes.TRAIT_DIFFERENCES,
  },
  {
    text: "Narrative: Brief Summary",
    value: QuestionInsightDisplayModes.BRIEF_NARRATIVE,
  },
  {
    text: "Narrative: Full Report",
    value: QuestionInsightDisplayModes.FULL_NARRATIVE,
  },
];

export default QuestionInsightDisplayModeOptions;
